
function exportDAR () {

    this.$eventBus.emit('show-dialog-page', {
      page: 'fatture-vendita-export-domestici-aziende-rappresentanti',
      title: 'Export',
      maximize: false,
    })
}

export default {
  'bindTo': 'this',
  'method': exportDAR,
}
